<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/permission/index' }">权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>权限添加</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-form :model="formData" label-width="100px">
          <el-form-item label="权限组名称">
            <el-col :span="12">
              <el-input size="small" v-model="formData.group_name" placeholder="请输入权限组名称"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="权限">
            <el-col :span="12">
              <el-tree
                ref="tree"
                :data="menuList"
                :check-on-click-node="true"
                show-checkbox
                node-key="id"
                @check-change="clickTreeNode"
              ></el-tree>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        group_name: "",
        group_jurisd_id: []
      },
      parentCode:[],
      menuList: []
    };
  },
  methods: {
    clickTreeNode() {
      this.formData.group_jurisd_id = this.$refs.tree.getCheckedKeys();
      this.parentCode = this.$refs.tree.getHalfCheckedKeys();
    },
    save() {
      if (this.formData.group_name == "") {
        this.$util.msg("请输入权限组名称");
      } else if (this.formData.group_jurisd_id.length == 0) {
        this.$util.msg("请选择权限");
      } else {
        let _group_jurisd_id = Array.from(new Set(this.parentCode.concat(this.formData.group_jurisd_id)));
        this.$ajax({
          loading: true,
          type: "post",
          url: "/permission/add",
          data: {
            group_name: this.formData.group_name,
            group_jurisd_id: _group_jurisd_id.join(",")
          }
        }).then(data => {
          this.$util.msg("添加成功", "success");
          setTimeout(() => {
            this.$router.push({ path: "/permission/index" });
          }, 1200);
        });
      }
    }
  },
  mounted() {
    this.$ajax({
      url: "/permission/tree"
    }).then(data => {
      this.menuList = this.$util.menuList(data.data);
    });
  }
};
</script>
<style>
</style>